import netcoServer from '../../apis/netcoServer';
import {GET_ALL_WEBSERVICE_USERS} from "../types";
import tableLoadingCall from '../helpers/tableLoadingCall';

const getAllWebserviceUsers= (page, pageSize, sord) => async (dispatch) => {
  let formData = {
    limit: pageSize,
    skip: (page - 1) * pageSize,
    sord: sord ? renderSord(sord) : '',
  };
  await tableLoadingCall(dispatch, () => netcoServer.newPost('/SystemService/getAllWebserviceUsers', formData), GET_ALL_WEBSERVICE_USERS, onSuccessPayload);
};

const renderSord = sord => {
  return sord === 'ascend' ? 'asc' : 'desc';
};

const onSuccessPayload = data => {
  return {
    reportList: {
      kind: 'webservices',
      total: data.result.total,
      entries: data.result.webserviceusersInfo
    }
  };
};
export default getAllWebserviceUsers;